import {Credit} from '../../../shared-gen/Model/Financial/Credit';

export class CreditFun {

	/**
	 * Returns a credit of 0.
	 */
	static none(): Credit {
		return {
			TotalCents: 0,
			HardCashCents: 0,
			CashlessCents: 0,
			ClosedLoopCents: 0,
			ApiCreditCents: 0,
			VoucherCents: 0,
			Voucher: null as any,
			HardCash: null as any,
			Cashless: null as any,
			ClosedLoop: null as any,
			ApiCredit: null as any
		};
	}

}

